import React, { forwardRef } from 'react'
import { DropdownItem, DropdownItemProps } from 'react-bootstrap'
import { Link } from 'react-router-dom'

interface Props {
    a?: string
    link?: string
    text: string
    icon?: string
    onClick?: () => void
}

export const AdvancedDropdownItem = forwardRef<HTMLButtonElement, Props & DropdownItemProps>(({ text, link, a, icon, ...rest }, ref) => {
    if (a) {
        return <DropdownItem as='a' href={a} {...rest}>
            {icon && <i className={`bi ${icon} me-2`} />}
            {text}
        </DropdownItem>
    }

    if (link) {
        return <DropdownItem as={Link} to={link} {...rest}>
            {icon && <i className={`bi ${icon} me-2`} />}
            {text}
        </DropdownItem>
    }

    return <DropdownItem {...rest} onClick={rest.onClick}>
        {icon && <i className={`bi ${icon} me-2`} />}
        {text}
    </DropdownItem>

})

